export function categoryTextMapper(input: string): string | null {
  return input === '-' ? null : input
}
